import { Badge, Skeleton, Stack, Typography } from '@mui/material';
import { Chip, Show } from '@side/pantry';

interface Props {
  label: string;
  total: number;
  totalNew: number;
  loading: boolean;
}

export const ListingStatusTotals = ({
  label,
  total,
  totalNew,
  loading,
}: Props) => {
  return (
    <Show when={total > 0 || loading}>
      <Stack direction="row" spacing={0.75} sx={{ alignItems: 'center' }}>
        <Show
          when={!loading}
          fallback={
            <Skeleton variant="rounded" sx={{ px: 2, borderRadius: 4 }} />
          }
        >
          <Chip
            size={{ xs: 'xs', md: 'small' }}
            label={total}
            variant="outlined"
          />
        </Show>
        <Typography>{label}</Typography>
        <Show when={totalNew > 0}>
          <Badge color="secondary" variant="dot" sx={{ pl: 2.5 }} />
          <Typography
            variant="h5"
            component="span"
            color="secondary"
            sx={{ pl: 0.5 }}
          >{`${totalNew} new`}</Typography>
        </Show>
      </Stack>
    </Show>
  );
};
